/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AccountLookupsService {

    /**
     * Resolves the canonical Hire account for an enterprise user email
     * @param email User email to resolve
     * @param xAccessToken API Token
     * @returns any user resolved
     * @throws ApiError
     */
    public static getInternalApiWxAccountLookup(
        email: string,
        xAccessToken?: string,
    ): CancelablePromise<{
        user_found: boolean;
        canonical_hire_account_id?: string;
        direct_match?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/account_lookup',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            query: {
                'email': email,
            },
            errors: {
                400: `missing email`,
                401: `unauthorized`,
            },
        });
    }

}